<div class="d-flex analysis-layout">
  <!-- Left Sidebar Navigation -->
  <app-analysis-nav [analysisType]="analysisType" [config]="navConfig"> </app-analysis-nav>

  <!-- Main Content -->
  <div class="content-area">
    <h2>Project QC Statistics</h2>

    <div>
      <h4>Quality Control stats per sample</h4>
      <div class="table-actions" role="group" aria-label="Export quality control statistics">
        <button
          class="btn btn-outline-secondary"
          type="button"
          [disabled]="!projectViewData.data.length"
          (click)="copyTable()"
        >
          Copy
        </button>
        <button
          class="btn btn-outline-secondary"
          type="button"
          [disabled]="!projectViewData.data.length"
          (click)="exportExcel()"
        >
          Excel
        </button>
        <button
          class="btn btn-outline-secondary"
          type="button"
          [disabled]="!projectViewData.data.length"
          (click)="exportPdf()"
        >
          PDF
        </button>
      </div>
      @if (exportMessage) {
        <p class="export-message" role="status">{{ exportMessage }}</p>
      }
      <div class="global-filter">
        <label class="visually-hidden" for="gene-stats-global-filter">Search quality control statistics</label>
        <input
          id="gene-stats-global-filter"
          class="form-control"
          type="search"
          placeholder="Search all columns"
          [value]="globalFilter"
          (input)="onGlobalFilterChange($event, qcTable)"
        />
      </div>
      <div class="row">
        <div class="table-container">
          <p-table
            #qcTable
            [value]="projectViewData.data"
            [columns]="projectViewData.cols"
            [filters]="filters"
            [globalFilterFields]="globalFilterFields"
            (onFilter)="onTableFilter($event)"
            [paginator]="true"
            [rows]="10"
            [rowsPerPageOptions]="pageSizes"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            class="gene-stats-table"
          >
            <ng-template pTemplate="header" let-columns>
              <tr>
                @for (column of columns; track column.data) {
                  <th [pSortableColumn]="column.data">
                    <div class="table-header-content">
                      <span class="table-header-title">
                        {{ column.title }}
                        <p-sortIcon [field]="column.data"></p-sortIcon>
                      </span>
                      <p-columnFilter
                        [field]="column.data"
                        [type]="isNumericColumn(column) ? 'numeric' : 'text'"
                        display="menu"
                        [showOperator]="true"
                        [showMatchModes]="true"
                        [showAddButton]="true"
                        [filterButtonProps]="filterButtonProps"
                      />
                    </div>
                  </th>
                }
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns">
              <tr>
                @for (column of columns; track column.data) {
                  <td>{{ rowData[column.data] }}</td>
                }
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                <td [attr.colspan]="columns.length || 1">No quality control statistics available.</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
</div>
